export default function () {
    return function (icon) {
        return _.startsWith(icon, 'logo-') ? icon : 'md-' + icon;
    };
}